var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from 'mobx';
import { api } from 'helpers/Api';
import { Branch } from './Model';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.branches = [];
        this.loaded = false;
        this.set = function (branches) {
            _this.branches = branches.map(function (branch) { return new Branch(branch); });
            _this.loaded = true;
        };
        this.push = function (branch) {
            _this.branches.push(new Branch(branch));
        };
        this.replace = function (branch) {
            _this.branches.splice(_this.branches.findIndex(function (f) { return f.id === branch.id; }), 1, branch);
        };
        this.pull = function (branch) {
            _this.branches.splice(_this.branches.findIndex(function (a) { return a.id === branch.id; }), 1);
        };
    }
    default_1.prototype.read = function (id) {
        var _this = this;
        if (id)
            return api.get('branch/' + id).then(function (branch) { return new Branch(branch); });
        return api.get('branch').then(function (branches) {
            _this.set(branches);
            return branches;
        });
    };
    default_1.prototype.create = function (branch) {
        return api.post('branch', branch).then(this.push);
    };
    default_1.prototype.update = function (id, branch) {
        return api.put('branch/' + id, branch).then(this.replace);
    };
    default_1.prototype.disable = function (id, disabled) {
        return api.patch('branch/' + id, { disabled: disabled }).then(this.pull);
    };
    __decorate([
        observable
    ], default_1.prototype, "branches", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loaded", void 0);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    __decorate([
        action
    ], default_1.prototype, "push", void 0);
    __decorate([
        action
    ], default_1.prototype, "replace", void 0);
    __decorate([
        action
    ], default_1.prototype, "pull", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Branches/Store.ts
// module id = 693
// module chunks = 0